import React from 'react';
import { MTDIcon } from '../../../components/Icon';

interface Props {
  title: string;
  onClose: () => void;
}

const PopupTitle = function PopupTitle({ title, onClose }: Props) {
  return (
    <div
      style={{
        position: 'relative',
        fontSize: '1.13rem',
        textAlign: 'center',
        lineHeight: '1.63rem',
        margin: '0.88rem auto',
      }}
    >
      <div style={{ position: 'absolute', right: '1rem', top: '0.18rem' }}>
        <MTDIcon icon="mtdicon-close" width="1.25rem" height="1.25rem" onClick={onClose} />
      </div>
      {title}
    </div>
  );
};

export default PopupTitle;
